module.exports = __webpack_public_path__ + "static/media/cra.f8fe1bae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cra.jpg
// module id = 730
// module chunks = 0